import React from 'react';
import { Heading, HeadingProps } from '@chakra-ui/react';

interface PageTitleProps extends Omit<HeadingProps, 'as'> {
  children: React.ReactNode;
}

const PageTitle: React.FC<PageTitleProps> = ({ children, ...props }) => {
  return (
    <Heading
      as="h1"
      fontFamily="Audiowide"
      fontWeight="bold"
      color="white"
      fontSize="2xl"
      m={0}
      p={0}
      display="flex"
      alignItems="center"
      {...props}
    >
      {children}
    </Heading>
  );
};

export default PageTitle; 